import qs from 'query-string';
import gameRecordId from './game-record-id';

const paramsKey = (id: string) => `hospitalia-params-${id}`;

type DefaultParams = {
  demoId: string;
  role: string;
  gameId: string;
  playerId: string;
  team: string;
};

export const parseGameIdString = (demoId: string): DefaultParams | null => {
  if (!demoId) return null;

  const [sessionId, rest] = demoId.split('::');
  const [gameId, playerId] = rest?.split(':') || [];
  const [role, team] = playerId?.split('.') || [];

  if (!sessionId || !gameId || !playerId || !role || !team) return null;

  return {
    demoId,
    role,
    team,
    gameId: gameRecordId(sessionId, gameId),
    playerId,
  };
};

export const extractDefaultGameParams = (gameId: string) => {
  if (typeof window === 'undefined') return;

  const fromStorage = JSON.parse(
    localStorage.getItem(paramsKey(gameId)) || 'null'
  ) as DefaultParams | null;

  if (fromStorage) return fromStorage;

  // Fallback: try parsing the gameId string directly
  // This supports direct URLs like /games/Session::Game:Role.Team
  return parseGameIdString(gameId) || ({} as DefaultParams);
};

export const saveDefaultGameParams = () => {
  if (typeof window === 'undefined') return;

  const parsed = qs.parse(location.search);
  const demoId = parsed?.demoId?.toString();
  if (!demoId) return;

  const params = parseGameIdString(demoId);

  if (!params)
    throw new Error(
      'Invalid demoId param, format should be `sessionId::gameId:role.T1`!'
    );

  localStorage.setItem(
    paramsKey(demoId),
    JSON.stringify(params)
  );
};
